import AuthService from "../../service";
const ourService = {
  getOurService(page,search) {
    return AuthService.get(`our-service?`+
      `page=${page}` +
      `&search=${search}`
    );
  },
  showOurService(id) {
    return AuthService.get("/our-service/" + id);
  },
  createOurService(data) {
    return AuthService.post("/our-service", data);
  },
  updateOurService(id, data) {
    return AuthService.put("/our-service/" + id, data);
  },
  deleteOurService(id) {
    return AuthService.delete("/our-service/" + id);
  },
  showOurServiceDetail(id) {
    return AuthService.get("/our-service-detail/" + id);
  },
  createOurServiceDetail(data) {
    console.log('create' , data)
    return AuthService.post("/our-service-detail", data);
  },
  updateOurServiceDetail(id, data) {
    return AuthService.put("/our-service-detail/" + id, data);
  },
  deleteOurServiceDetail(id) {
    return AuthService.delete("/our-service-detail/" + id);
  },
  getOurServiceDetailFromServiceId(id) {
    return AuthService.get(`/our-service/details/${id}`);
  }
};
export default ourService;
